import { useEffect, useState } from 'react';
import { C, F, SiteHeader, SiteFinalCta, SiteFooter } from '../components/SiteChrome';
import { BlogCard } from '../components/BlogCard';
import { fetchPosts } from '../lib/blogApi';
import { usePageSeo } from '../lib/seo';

/**
 * Every published post in one grid, newest first by date. The landing page
 * shows the same posts in a carousel; this is the page that lists them all.
 */
const Blog = () => {
    const [posts, setPosts] = useState(null);

    usePageSeo({
        title: 'French Speaking & Pronunciation Practice Blog | Mimique',
        description: 'Freezing mid-conversation, pronunciation nobody teaches you, and what actually helps you speak French confidently. Notes from someone still learning French.',
        canonical: 'https://mimique.app/blog',
    });

    useEffect(() => {
        let live = true;
        fetchPosts()
            .then((list) => {
                const byDate = [...list].sort((a, b) => (b.date || '').localeCompare(a.date || ''));
                if (live) setPosts(byDate);
            })
            .catch(() => { if (live) setPosts([]); });
        return () => { live = false; };
    }, []);

    return (
        <div style={{ minHeight: '100vh', background: '#ffffff', color: C.deep, fontFamily: F.body }}>
            <SiteHeader />

            <div style={{ background: C.paleBg, padding: '80px 24px 100px' }}>
                <div style={{ maxWidth: 1160, margin: '0 auto' }}>
                    <div style={{ maxWidth: 640, margin: '0 auto 56px', textAlign: 'center' }}>
                        <div style={{ fontSize: 13, fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', color: C.primary, marginBottom: 14 }}>
                            Blog
                        </div>
                        <h1 style={{ margin: '0 0 16px', fontFamily: F.heading, fontSize: 38, fontWeight: 700, color: C.deep }}>
                            Notes from someone still learning
                        </h1>
                        <p style={{ margin: 0, fontSize: 16, lineHeight: 1.6, color: C.bodyOnWhite }}>
                            Freezing mid-conversation, pronunciation nobody teaches you, and what actually helped.
                            My experience, and what I found when I went looking.
                        </p>
                    </div>

                    {posts === null ? (
                        <div style={{ textAlign: 'center', color: C.light, fontSize: 15 }}>Loading...</div>
                    ) : posts.length === 0 ? (
                        <div style={{ textAlign: 'center', color: C.light, fontSize: 15 }}>No posts yet.</div>
                    ) : (
                        <div style={{ display: 'grid', gap: 24, gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))' }}>
                            {posts.map((post) => <BlogCard key={post.slug} post={post} />)}
                        </div>
                    )}
                </div>
            </div>

            <SiteFinalCta compact />
            <SiteFooter />
        </div>
    );
};

export default Blog;
